export const MERGE_CARTS_COOKIE_NAME = 'mergeCarts';

export type MergeCartsCookieContent = Record<
  string,
  {
    necessary: boolean;
  }
> | null;

export function useMergeCartsCookie(): Ref<MergeCartsCookieContent> {
  return useCookie<MergeCartsCookieContent>(MERGE_CARTS_COOKIE_NAME);
}
